/* eslint-disable @typescript-eslint/naming-convention */
import type { Nullable } from '../../../types';
import { User } from '../../user';
import type { ISubject } from './iSubject';

export default class Subject implements ISubject {
  id: string;

  email: string;

  firstName: Nullable<string>;

  lastName: Nullable<string>;

  verified: boolean;

  constructor(
    id: string,
    email: string,
    firstName: Nullable<string>,
    lastName: Nullable<string>,
    verified = false
  ) {
    this.id = id;
    this.email = email;
    this.firstName = firstName;
    this.lastName = lastName;
    this.verified = verified;
  }

  static createUnverified(user: User): Subject {
    return new Subject(
      user.id,
      user.email,
      user.firstName,
      user.lastName,
      false
    );
  }

  toRequestData(): {
    id: string;
    email: string;
    first_name: Nullable<string>;
    last_name: Nullable<string>;
    verified: boolean;
  } {
    return {
      id: this.id,
      email: this.email,
      first_name: this.firstName,
      last_name: this.lastName,
      verified: this.verified,
    };
  }
}
